import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const bottleSizesSchema: CollectionCreateSchema = {
  name: CollectionName.BottleSizes,
  fields: [
    {
      name: "label",
      type: "string",
      facet: false,
      infix: true,
      sort: true,
    },
  ],
  visibility: CollectionVisibility.EC,
}
